<template>
  <div>
    <div v-if="loading" style="font-size:1rem;color:#9e9e9e;text-align:center;margin-top:10rem;">
      <LoadingText />
    </div>
    <div v-else>
        <v-card flat style="padding:0.8rem 0.2rem 1rem;">
            <div v-if="detailInfo.BIZ_SID < 4">
              <v-row style="margin:auto;">
                <v-col cols="6" style="padding:0;text-align:center;">
                  <v-btn large color="primary" @click="setOrderProcessed" v-if="detailInfo.BIZ_SID === 0">我来处理</v-btn>
                  <v-btn large color="#92beea" style="color:#fff;" @click="setOrderProcessed" depressed v-else>我来处理</v-btn>
                </v-col>
                <v-col cols="6" style="padding:0;text-align:center;">
                  <v-btn large color="warning" @click="setOrderFinish" v-if="selfUserInfo.usercode === detailInfo.CREATOR_CODE">确认完成</v-btn>
                  <v-btn large color="#fdc886" style="color:#fff;" @click="setOrderFinish" depressed v-else>确认完成</v-btn>
                </v-col>
              </v-row>
            </div>
            <div v-else>
              <v-row style="margin:auto;">
                <v-col cols="6" style="padding:0;text-align:center;">
                  <v-btn large style="background-color: rgba(0, 0, 0, 0.12) !important;color: rgba(0, 0, 0, 0.26) !important;" depressed @click="setOrderProcessed">我来处理</v-btn>
                </v-col>
                <v-col cols="6" style="padding:0;text-align:center;">
                  <v-btn large style="background-color: rgba(0, 0, 0, 0.12) !important;color: rgba(0, 0, 0, 0.26) !important;" depressed @click="setOrderFinish">确认完成</v-btn>
                </v-col>
              </v-row>
            </div>
            <v-divider style="margin:1rem 0;" />
            <!-- <div style="margin-bottom:0.84rem;"><PriorityLabel :value="detailInfo.GZ_PRIORITY" noStyle size="large" /></div> -->
            <v-row no-gutters style="margin-top:1.2rem;">
              <v-col cols="4" style="padding-left:0.2rem;padding-top: 0.5rem;" class="us-label">
                <span class="us-icon"><i class="fa fa-circle-o-notch" aria-hidden="true" /></span>
                <span>优先级</span>
              </v-col>
              <v-col cols="8">
                <div><PriorityLabel :value="detailInfo.GZ_PRIORITY" noStyle size="large" /></div>
              </v-col>
            </v-row>
            <v-row no-gutters style="margin-top:1.2rem;">
              <v-col cols="4" style="padding-left:0.2rem;" class="us-label">
                <span class="us-icon"><i class="fa fa-hashtag" aria-hidden="true" /></span>
                <span>标题</span>
              </v-col>
              <v-col cols="8" class="show-content" style="font-size: 1.1rem;">
                {{detailInfo.GZ_TITLE}}
              </v-col>
            </v-row>
            <v-row no-gutters style="margin-top:1.1rem;">
              <v-col cols="4" style="padding-left:0.2rem;" class="us-label">
                <span class="us-icon"><i class="fa fa-align-left" aria-hidden="true" /></span>
                <span>内容</span>
              </v-col>
              <v-col cols="8" class="show-content" style="font-size: 1.1rem;">
                {{ (detailInfo.GZ_CONTENT && detailInfo.GZ_CONTENT !=='') ? detailInfo.GZ_CONTENT : '&lt;空&gt;' }}
              </v-col>
            </v-row>
            <!-- <v-row no-gutters style="margin-top:0.3rem;">
              <v-col cols="12" style="text-indent:1.71em;line-height:1.5rem;">
                {{ (detailInfo.GZ_CONTENT && detailInfo.GZ_CONTENT !=='') ? detailInfo.GZ_CONTENT : '&lt;空&gt;' }}
              </v-col>
            </v-row> -->
            <!-- <v-row no-gutters style="margin-top:0.95rem;">
                <v-col cols="4" style="padding-left:0.2rem;" class="us-label">
                    <span class="us-icon"><i class="fa fa-picture-o" aria-hidden="true" /></span>
                    <span>故障图片</span>
                </v-col>
                <v-col cols="8">

                </v-col>
            </v-row> -->
            <div style="margin-top:0.5rem;">
                <viewer :images="pictures">
                  <v-row style="margin:0;">
                    <v-col v-for="(pt,index) in pictures" :key="index" cols="4" style="padding:6px;margin-top:0.29rem;">
                      <div style="width:100px;height:100px;">
                        <img
                        :src="pt.PICTURE_THUMB_URL"
                        :data-original="pt.PICTURE_URL"
                        onError='this.src="/res/default_img.jpg";this.onerror=null;'
                        alt="A"
                        class="img-rounded"
                        style="width:100%;height:100%;border-radius:5px;border:1px solid #f2f2f2;" />
                      </div>
                    </v-col>
                  </v-row>
                </viewer>
            </div>
            <v-row no-gutters style="margin-top:1rem;">
                <v-col cols="4" style="padding-left:0.2rem;" class="us-label">
                    <span class="us-icon"><i class="fa fa-file-code-o" aria-hidden="true" /></span>
                    <span>单号</span>
                </v-col>
                <v-col cols="8">
                    {{detailInfo.GZ_ORDER_CODE}}
                </v-col>
            </v-row>
            <v-row no-gutters style="margin-top:1.2rem;">
              <v-col cols="4" style="padding-left:0.2rem;" class="us-label">
                <span class="us-icon"><i class="fa fa-calendar-plus-o" aria-hidden="true" /></span>
                <span>创建时间</span>
              </v-col>
              <v-col cols="8">
                {{$moment(detailInfo.ROW_DATE_CREATE).format("YYYY-MM-DD HH:mm:ss")}}
              </v-col>
            </v-row>
            <v-row no-gutters style="margin-top:1.25rem;">
              <v-col cols="4" style="padding-left:0.2rem;" class="us-label">
                <span class="us-icon"><i class="fa fa-building-o"  aria-hidden="true" style="margin-right:0.1rem;" /></span>
                <span>团队</span>
              </v-col>
              <v-col cols="8">
                <span v-if="curCompanyInfo">{{curCompanyInfo.COMPANY_NAME}}</span>
              </v-col>
            </v-row>
            <v-row no-gutters style="margin-top:1.25rem;">
              <v-col cols="4" style="padding-left:0.2rem;" class="us-label">
                <span class="us-icon"><i class="fa fa-caret-square-o-down" aria-hidden="true" style="font-size:1.1rem;margin-right:0.1rem;" /></span>
                <span>状态</span>
              </v-col>
              <v-col cols="8">
                <GzBizSidLabel :value="detailInfo.BIZ_SID" />
              </v-col>
            </v-row>
            <v-row no-gutters style="margin-top:0.8rem;">
              <v-col cols="4" style="padding-left:0.2rem;" class="us-label">
              <div style="margin-top:0.7rem;">
                <span class="us-icon"><i class="fa fa-user-circle-o"  aria-hidden="true" style="margin-right:0.099rem;" /></span>
                <span>创建人</span>
              </div>
              </v-col>
              <v-col cols="8">
                <v-row style="margin-left:0rem;" v-if="creatorInfo">
                  <v-col :cols="2"  style="padding:0;margin-top:0.22rem;">
                    <v-avatar size="36">
                      <img :src="creatorInfo.HEAD_IMAGE_URL" alt="1" >
                    </v-avatar>
                  </v-col>
                  <v-col :cols="10">
                    <span v-if="creatorInfo.USER_NAME">{{creatorInfo.USER_NAME}}</span>
                    <span v-else>{{creatorInfo.NICK_NAME}}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <!-- <v-row no-gutters style="margin-top:1.2rem;">
                <v-col cols="4" style="padding-left:0.2rem;">
                    <span class="us-icon"><i class="fa fa-calendar" aria-hidden="true" style="margin-right:0.4rem;" /></span>
                    <span>故障时间</span>
                </v-col>
                <v-col cols="8">
                    {{detailInfo.GZ_DATE_TIME}}
                </v-col>
            </v-row>
            -->

            <!-- <v-row no-gutters style="margin-top:0.8rem;">
                <v-col cols="4" style="padding-left:0.2rem;">
                    <span class="us-icon"><i class="fa fa-clock-o" aria-hidden="true" style="margin-right:0.4rem;font-size:1rem;" /></span>
                    <span>故障时长</span>
                </v-col>
                <v-col cols="8">
                    {{getDuration(detailInfo.GZ_DATE_TIME)}}
                </v-col>
            </v-row> -->

            <!-- <v-row no-gutters style="margin-top:1.1rem;">
                <v-col cols="4" style="padding-left:0.2rem;" class="us-label">
                <div style="margin-top:0.7rem;">
                    <span class="us-icon"><i class="fa fa-user-circle-o" aria-hidden="true" style="margin-right:0.5rem;" /></span>
                    <span>执行人</span>
                </div>
                </v-col>
                <v-col cols="8" >
                    <v-row style="margin-left:0rem;" v-if="execPlayerInfo">
                        <v-col :cols="2"  style="padding:0;margin-top:0.22rem;">
                            <v-avatar size="36">
                                <img :src="execPlayerInfo.HEAD_IMAGE_URL" alt="1" >
                            </v-avatar>
                        </v-col>
                        <v-col :cols="10">
                        <span>{{execPlayerInfo.NICK_NAME}}</span>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row> -->

            <v-row no-gutters style="margin-top:0.5rem;">
              <v-col cols="4" style="padding-left:0.2rem;padding-top:0.1rem;" class="us-label">
              <div style="margin-top:0.7rem;">
                <span class="us-icon"><i class="fa fa-user-circle-o" aria-hidden="true" style="margin-right:0.099rem;" /></span>
                <span>参与人</span>
              </div>
              </v-col>
              <v-col cols="8" style="padding-top:0.1rem;">
                <PlayerList ref="PlayerList" :order-code="orderCode" :worker-code="detailInfo.WORKER_CODE" :user-code="selfUserInfo.usercode" :function-disabled.sync="functionDisabled" />
              </v-col>
            </v-row>

            <v-row no-gutters style="margin-top:0.5rem;">
              <v-col cols="4" style="padding-left:0.2rem;padding-top:0.1rem;" class="us-label">
                <div style="margin-top:0.7rem;">
                  <span class="us-icon"><i class="fa fa-picture-o" aria-hidden="true" style="margin-right:0.115rem;" /></span>
                  <span>完成照片</span>
                </div>
              </v-col>
              <v-col cols="8" style="padding-top:0.1rem;">
              </v-col>
            </v-row>
            <div style="margin-top:0.5rem;">
              <PhotoWall :order-code="orderCode" :hasUploadIcon="detailInfo.BIZ_SID < 4 && (selfUserInfo.usercode === detailInfo.CREATOR_CODE ? true : !functionDisabled)" />
            </div>
            <v-row no-gutters style="margin-top:1.25rem;" v-if="detailInfo.BIZ_SID === 4">
              <v-col cols="4" style="padding-left:0.2rem;" class="us-label">
                <span class="us-icon"><i class="fa fa-calendar-check-o" aria-hidden="true" /></span>
                <span>完成时间</span>
              </v-col>
              <v-col cols="8">
                {{$moment(detailInfo.GZ_FINISH_TIME).format("YYYY-MM-DD HH:mm:ss")}}
              </v-col>
            </v-row>

            <!-- <v-row no-gutters style="margin-top:1.2rem;padding-bottom:0.15rem;" v-if="detailInfo.BIZ_SID === 4">
                <v-col cols="4" style="padding-left:0.2rem;padding-top:0.29rem;" class="us-label">
                    <span class="us-icon"><i class="fa fa-star-o" aria-hidden="true" style="margin-right:0.4rem;font-size:1rem;" /></span>
                    <span>故障评价</span>
                </v-col>
                <v-col cols="8">
                <v-rating v-model="detailInfo.GZ_RATE"  class="us-v-rating" background-color="orange lighten-3" color="orange" readonly ></v-rating>
                </v-col>
            </v-row> -->

            <!-- <v-row no-gutters style="margin-top:0.6rem;">
                <v-col cols="4" style="padding-left:0.2rem;" class="us-label">
                    <span class="us-icon"><i class="fa fa-link" aria-hidden="true" style="margin-right:0.4rem;" /></span>
                    <span>备注说明</span>
                </v-col>
                <v-col cols="8">
                    {{detailInfo.GZ_REMARK}}
                </v-col>
            </v-row> -->

        </v-card>
        <!-- <v-divider style="margin:1rem 0;"></v-divider> -->
        <div style="margin:0;padding-bottom:5rem;">
          <div style="padding:0.3rem 0.5rem;">故障动态</div>
          <ChatMsg :order-code="orderCode" :showInput="detailInfo.BIZ_SID < 4 && (selfUserInfo.usercode === detailInfo.CREATOR_CODE ? true : !functionDisabled)" @scroll-footer="scrollFooter" @has-new-op="hasNewOp" />
        </div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import PriorityLabel from '../../../components/PriorityLabelV2'
import GzBizSidLabel from '../../../components/GzBizSidLabel'
import PlayerList from './PlayerList'
import ChatMsg from '../../../components/ChatMsg'
import LoadingText from '../../../components/LoadingText'
import PhotoWall from './PhotoWall'
export default {
  components: { PriorityLabel, GzBizSidLabel, PlayerList, ChatMsg, LoadingText, PhotoWall },
  props: {
    companyInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      detailInfo: {
        GZ_TITLE: '模拟测试故障-无法连接网络',
        GZ_CONTENT: '',
        GZ_ORDER_CODE: '20200701001',
        ROW_DATE_CREATE: '2020-07-01 20:13:42',
        GZ_DATE_TIME: '2020-07-01 20:07:34',
        GZ_PRIORITY: 2,
        GZ_REMARK: '测试看看',
        BIZ_SID: 0,
        GZ_RATE: 3,
        GZ_FINISH_TIME: '2020-07-02 13:53:14'
      },
      pictures: [],
      curOrderLink: 'http://www.baidu.com?test=123',
      orderCode: '',
      loading: true,
      creatorInfo: {},
      execPlayerInfo: {},
      selfUserInfo: {},
      curCompanyName: '',
      functionDisabled: true
    }
  },
  computed: {
    curCompanyInfo: {
      get() {
        return this.companyInfo
      },
      set(val) {
        this.$emit('update:companyInfo', val)
      }
    }
  },
  mounted() {
    var that = this
    that.orderCode = that.$route.params.code
    that.initData()
    window.scroll(0, 0);
  },
  created() {
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    getDuration(from, to) {
      var text = this.$moment(from).from(to)
      text = text.replace('前', '')
      return text
    },
    copyLink() {
      var that = this
      var clipboard = new that.$clipboard('.us-clipboard');
      clipboard.on('success', function() {
        that.$toast.success('复制成功')
      });
      clipboard.on('error', function() {
        that.$toast.warning('复制失败')
      });
    },
    configShareOrder() {
      var that = this
      var sImage = that.$AppHelper.getShareLink('/res/favicon.png')
      if (that.pictures.length > 0) {
        var firstP = that.pictures[0]
        // sImage = that.$api.bz.getGzPictureUrl(firstP.PICTURE_THUMB_URL)
        if (firstP.PICTURE_THUMB_URL && firstP.PICTURE_THUMB_URL !== '') {
          sImage = firstP.PICTURE_THUMB_URL
        }
      }
      that.curOrderLink = that.$AppHelper.getShareLink('/ShareOrder/' + that.orderCode);
      // console.log('curOrderLink', that.curOrderLink);
      wx.updateAppMessageShareData({
        title: that.detailInfo.GZ_TITLE,
        // desc: '团队: ' + that.curCompanyName + '\n' + '内容: ' + ((that.detailInfo.GZ_CONTENT && that.detailInfo.GZ_CONTENT !== '') ? that.detailInfo.GZ_CONTENT : '<空>'),
        desc: ((that.detailInfo.GZ_CONTENT && that.detailInfo.GZ_CONTENT !== '') ? '内容: ' + that.detailInfo.GZ_CONTENT + '\n' : '') + '团队: ' + that.curCompanyName,
        // desc: '时间: ' + that.$moment(that.detailInfo.ROW_DATE_CREATE).format('YYYY-MM-DD HH:mm:ss') + '\n' + that.detailInfo.GZ_CONTENT,
        link: that.curOrderLink,
        imgUrl: sImage,
        success: function(res) {
          // 设置成功
          console.log('配置分享内容.OK');
          // that.$toast.success('配置成功');
        },
        error: function(e) {
          // console.log('配置分享内容.ERROR');
          // that.$toast.warning('配置失败');
        }
      })
    },
    initData() {
      var that = this
      that.selfUserInfo = that.$AppHelper.getUserInfo()
      that.$api.bz.queryOrderDetail({ order_code: that.orderCode }).then(res => {
        // console.log('queryOrderDetail.res', res);
        if (!res.success) {
          // that.$toast.error('获取报障信息失败');
          console.log('获取报障信息失败', res);
          return
        }
        var data = res.data
        that.detailInfo = data.order
        that.pictures = data.pictures
        that.creatorInfo = data.creator
        that.curCompanyName = data.company.COMPANY_NAME
        that.curCompanyInfo = data.company
        that.execPlayerInfo = data.exec_player
        that.configShareOrder();
        that.loading = false
        that.setdisabled()
      })
    },
    async setOrderFinish() {
      var that = this
      if (that.detailInfo.BIZ_SID === 4) {
        that.$toast.warning('已经完成了，无法更改.');
        return
      }
      if (that.selfUserInfo.usercode !== that.detailInfo.CREATOR_CODE) {
        that.$toast.warning('请联系创建人确认完成.');
        return
      }
      var res = await that.$api.bz.setOrderFinish({ order_code: that.orderCode })
      if (!res.success) {
        that.$toast.warning(res.error_msg ? res.error_msg : '操作失败');
        return
      }
      that.$toast.success('操作成功')
      that.initData()
      // setTimeout(function() {
      //   that.goBack()
      // }, 1500);
    },
    scrollFooter() {
      var that = this
      that.$nextTick(() => {
        setTimeout(() => {
          var detail = document.getElementById('us-v-app')
          window.scroll(detail.scrollHeight, detail.scrollHeight);
        }, 2000)
      })
    },
    async setOrderProcessed() {
      var that = this
      if (that.detailInfo.BIZ_SID === 2) {
        that.$toast.warning('已经在处理中.');
        return
      }
      if (that.detailInfo.BIZ_SID === 4) {
        that.$toast.warning('已经完成了，无法更改.');
        return
      }
      var res = await that.$api.bz.setOrderProcessed({ order_code: that.orderCode })
      if (!res.success) {
        that.$toast.warning(res.error_msg ? res.error_msg : '操作失败');
        return
      }
      that.$toast.success('操作成功')
      // setTimeout(function() {
      //   that.goBack()
      // }, 1500);
      that.initData()
      that.$refs.PlayerList.getList();
    },
    showDefaultImg() {
      return 'this.src="/res/default_img.jpg";'
    },
    hasNewOp() {
      this.initData();
    },
    setdisabled() {
      var that = this
      if (that.detailInfo.BIZ_SID === 4) {
        return
      }
      if (that.selfUserInfo.usercode !== that.detailInfo.CREATOR_CODE) {
        that.$emit('exit', false)
        return
      } else {
        that.$emit('delete', false)
      }

    },
    exitPlayer() {
      var that = this
      that.$confirm('确定要退出？', '提示').then(async function() {
        var res = await that.$api.bz.exitPlayer({ order_code: that.orderCode })
        if (!res.success) {
          that.$toast.warning(res.error_msg ? res.error_msg : '退出失败');
          return
        }
        that.$toast.success('退出成功')
        setTimeout(function() {
          that.goBack();
        }, 1000);
      }, function() {})
    },
    deleteOrder() {
      var that = this
      that.$confirm('确定要删除？', '提示').then(async function() {
        var res = await that.$api.bz.deleteOrder({ order_code: that.orderCode })
        if (!res.success) {
          that.$toast.warning(res.error_msg ? res.error_msg : '删除失败');
          return
        }
        that.$toast.success('删除成功')
        setTimeout(function() {
          that.goBack();
        }, 1000);
      }, function() {})
    }
  }
}
</script>

<style scoped>

.us-icon{
  width: 30px;
  max-width: 30px;
  display: inline-block;
  text-align: center !important;
}

.us-icon i{
  font-size: 1rem;
}

.us-v-rating >>> .v-icon{
  padding: 0.1rem !important;
}

.us-label{
  color: #9b9b9b;
}

.show-content{
  /*保留空白并且正常换行*/
  white-space: pre-wrap;
}
</style>
